// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac119fc5","732":"de32ee7e","977":"c38a2a7b"}[chunkId] + ".chunk.js";
};